import type { DrawLevel } from '@ps/web-shared-api-types/v1-preview/SwPkrSpinAndGo';
import { Translation } from '@ps/web-shared-components';

import { Multiplier } from '../Multiplier/Multiplier';
import Prize from '../Prize/Prize';
import styles from '../shared.scss';

import { TXTCLI_Multiplier, TXTCLI_Probability_1M } from './ProbabilityInfo.messages.json';

interface ProbabilityInfoProps {
  buyIn: number;
  rake: number;
  drawLevels?: DrawLevel[];
  isPlayMoney: boolean;
  currency: number;
}

export const ProbabilityInfo: React.FC<ProbabilityInfoProps> = ({
  buyIn,
  rake,
  drawLevels = [],
  isPlayMoney,
  currency
}) => {
  const odds = drawLevels.length ? drawLevels[0].odds : null;

  const totalBuyIn = buyIn + rake;

  return (
    <table className={styles.scrollableTable}>
      <thead className="probability-info-header">
        <tr className="probability-info-header-row">
          {totalBuyIn > 0 && <Translation tagName="th" {...TXTCLI_Multiplier} />}
          {odds && <Translation tagName="th" {...TXTCLI_Probability_1M} />}
        </tr>
      </thead>
      <tbody className="probability-info-body">
        {drawLevels.map(
          ({ odds, prizePool }, i) =>
            totalBuyIn > 0 &&
            prizePool && (
              <tr key={`${odds}-${i}`} className="probability-info-body-row">
                <Multiplier
                  totalBuyIn={totalBuyIn}
                  prizePool={prizePool}
                  isPlayMoney={isPlayMoney}
                />
                {odds && <Prize value={odds} currency={currency} />}
              </tr>
            )
        )}
      </tbody>
    </table>
  );
};
